import { render } from "./uncheck-risk-modal.vue?vue&type=template&id=8af0d312&scoped=true&ts=true"
import script from "./uncheck-risk-modal.vue?vue&type=script&lang=ts"
export * from "./uncheck-risk-modal.vue?vue&type=script&lang=ts"

import "./uncheck-risk-modal.vue?vue&type=style&index=0&id=8af0d312&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af0d312"]])

export default __exports__